require('../scss/app.scss');

require('./components/accordion');
require('./components/icon-sprites');
require('./components/enable-css-transition');
require('./components/burger-nav');
require('./components/modal');
require('./components/scroll');
require('./components/slides');
require('./components/table-of-content');
require('./components/BlogPostLoadMore');
